// @ts-strict-ignore
import { CarrierBlockVO, ProjectVO } from '@project/model/vo/project.vo';
import { ArrayUtils } from '@shared/util/array-utils';
import { ArticleUsageVO } from '@article/model/vo/article.vo';
import { CompositeArticleUtils } from '@article/util/composite-article-utils';
import { ArticleContainer } from '@3d-scene/model3d/article-container';
import { ArticleUsageUtils } from '@article/util/article-usage-utils';
import { ArticleUsageInfoPropertyDef } from '@article/constants/article-usage-info-property-def';

export class CarrierBlockUtils {
  public static getCarrierBlockByGuid(carrierBlocks: CarrierBlockVO[], blockGuid: string): CarrierBlockVO {
    if (!blockGuid || !carrierBlocks || carrierBlocks.length === 0) {
      return null;
    }
    for (const carrierBlock of carrierBlocks) {
      if (blockGuid === carrierBlock.guid) {
        return carrierBlock;
      }
    }
    return null;
  }

  public static findCarrierBlockByBmkName(carrierBlocks: CarrierBlockVO[], bmkName: string): CarrierBlockVO | undefined {
    if (!bmkName || !carrierBlocks || carrierBlocks.length === 0) {
      return undefined;
    }
    for (const carrierBlock of carrierBlocks) {
      if (bmkName === carrierBlock.structure) {
        return carrierBlock;
      }
    }
  }

  public static getCarrierBlockInProjectByGuid(project: ProjectVO, carrierBlockGuid: string): CarrierBlockVO {
    if (!project || !carrierBlockGuid) {
      return null;
    }
    return this.getCarrierBlockByGuid(project.carrierBlocks, carrierBlockGuid);
  }

  public static getCarrierBlockGuid(articleUsage: ArticleUsageVO): string {
    if (!articleUsage) {
      return null;
    }
    return ArticleUsageUtils.getArticleUsageInfoPropertyStringValue(articleUsage, ArticleUsageInfoPropertyDef.CARRIER_BLOCK_GUID);
  }

  public static getBmkName(articleUsage: ArticleUsageVO): string {
    if (!articleUsage) {
      return null;
    }
    return ArticleUsageUtils.getArticleUsageInfoPropertyStringValue(articleUsage, ArticleUsageInfoPropertyDef.CAE_ITEM_STRUCTURE);
  }

  public static applyCarrierBlockGuidByArticleUsage(
    articleUsage: ArticleUsageVO,
    carrierBlock: CarrierBlockVO,
    compositeArticleUtils: CompositeArticleUtils,
    bmkName: string,
  ): void {
    if (articleUsage == null || carrierBlock == null) {
      return;
    }

    if (ArrayUtils.isEmpty(carrierBlock.articleGuids)) {
      carrierBlock.articleGuids = [];
    }

    if (ArticleUsageUtils.isCompositePartArticleUsage(articleUsage)) {
      const baseCompositeContainers: ArticleContainer[] = compositeArticleUtils.getBaseCompositePartArticlesByArticleUsage(articleUsage);
      for (const baseContainer of baseCompositeContainers) {
        if (!this.getCarrierBlockGuid(baseContainer.articleUsage)) {
          this.setCarrierBlockGuidAndBmk(baseContainer.articleUsage, carrierBlock.guid, bmkName);
          if (!carrierBlock.containsArticleGuid(baseContainer.articleGUID)) {
            carrierBlock.articleGuids.push(baseContainer.articleGUID);
          }
        }
      }
    } else {
      this.setCarrierBlockGuidAndBmk(articleUsage, carrierBlock.guid, bmkName);
      if (!carrierBlock.containsArticleGuid(articleUsage.id)) {
        carrierBlock.articleGuids.push(articleUsage.id);
      }
    }
  }

  public static setCarrierBlockGuidAndBmk(articleUsage: ArticleUsageVO, carrierBlockGuid: string, bmkName: string): void {
    if (!articleUsage || !carrierBlockGuid) {
      return;
    }
    ArticleUsageUtils.setArticleUsageInfoPropertyStringValue(articleUsage, ArticleUsageInfoPropertyDef.CARRIER_BLOCK_GUID, carrierBlockGuid);
    ArticleUsageUtils.setArticleUsageInfoPropertyStringValue(articleUsage, ArticleUsageInfoPropertyDef.CAE_ITEM_STRUCTURE, bmkName);
  }

  public static removeCarrierBlockGuidAndBmk(articleUsage: ArticleUsageVO): void {
    ArticleUsageUtils.removeArticleUsageInfoProperty(articleUsage, ArticleUsageInfoPropertyDef.CARRIER_BLOCK_GUID);
    ArticleUsageUtils.removeArticleUsageInfoProperty(articleUsage, ArticleUsageInfoPropertyDef.CAE_ITEM_STRUCTURE);
  }
}
